import { includes, some } from 'lodash';

import type { AuthUser } from 'common/auth/types';
import type { BaseRoles } from 'common/graphql/types';
import { RoleVariantEnum } from 'common/graphql/types';
import type { RouteType } from 'common/types/route';

import { isInPath } from './common.utils';

const SPONSOR_DASHBOARD_ROLES: (BaseRoles | RoleVariantEnum)[] = [RoleVariantEnum.Monitor, RoleVariantEnum.DataManager];

export const PATIENT_AND_SITE_LISTING_ROLES: (BaseRoles | RoleVariantEnum)[] = [
    ...SPONSOR_DASHBOARD_ROLES,
    RoleVariantEnum.ProductSupport,
];

const SPONSOR_DASHBOARD_PERMISSIONS = [];

export const PATIENT_LISTING_ROUTE: RouteType = {
    permissions: SPONSOR_DASHBOARD_PERMISSIONS,
    path: '/patientlisting',
    role: PATIENT_AND_SITE_LISTING_ROLES,
    studyOnlyRequired: true,
};

export const SITE_LISTING_ROUTE: RouteType = {
    permissions: SPONSOR_DASHBOARD_PERMISSIONS,
    path: '/sitelisting',
    role: PATIENT_AND_SITE_LISTING_ROLES,
    studyOnlyRequired: true,
};

export const CTL_SITE_LISTING_ROUTE: RouteType = {
    permissions: SPONSOR_DASHBOARD_PERMISSIONS,
    path: '/ctlsitelisting',
    role: [RoleVariantEnum.ClinicalTrialLead],
    studyOnlyRequired: true,
};

export const SPONSOR_HOME_PATH = PATIENT_LISTING_ROUTE.path;
export const SPONSOR_PATHS_WITH_ACTIVE_SITE_SELECTION = ['/reports', '/siteDashboard', '/chart'];

export const isSponsorRole = (roleClaimSk: string): boolean => includes(SPONSOR_DASHBOARD_ROLES, roleClaimSk);

export const isSponsorUser = (authUser: AuthUser): boolean => isSponsorRole(authUser?.roleVClaim?.sk);

export const getNonSponsorHomePath = (authUser: AuthUser) =>
    authUser?.roleVClaim?.sk === RoleVariantEnum.ClinicalTrialLead ? '/study' : '/siteDashboard';

// Sponsor dashboard users (Monitors and others), need to select only study not a site for most pages. Some pages
// require a site to function though, so we keep a list of them here
export const isPathWithActiveSiteSelectionForSponsor = (path: string) =>
    some(SPONSOR_PATHS_WITH_ACTIVE_SITE_SELECTION, (pathWithActiveSiteSelection) => {
        return isInPath(path, pathWithActiveSiteSelection);
    });
